import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import Config from "config";
const SouscriptionsCard = ({ title, details, ids }) => {
  const backUrl = Config.backOffice.url;

  const api = Config.backOffice.apiName;
  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: 10 }}>
        {title}
      </CardTitle>
      <CardBody>
        {details ? (
          Object.entries(details).map(([key, value], index) => (
            <Row key={index} className="mb-3">
              <Col className="col-4" style={{ whiteSpace: "nowrap" }}>
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              </Col>
              <Col className="col-8" style={{ textAlign: "right" }}>
                <span
                  style={{
                    paddingInlineStart: "8em",
                    whiteSpace: "pretty",
                    fontFamily: "sans-serif",
                  }}
                >
                  {key.includes("€") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })
                  ) : key.includes("%") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " %"
                  ) : key == "Fichier" && value != null ? (
                    <a href={value} download>
                      <i
                        style={{
                          fontSize: "25px",
                          paddingLeft: "8px",
                          textalign: "center",
                          verticalalign: "middle",
                        }}
                        className="bx bx-download"
                      ></i>
                    </a>
                  ) : key == "Réservation" && ids?.reservation_id != null ? (
                    <Link
                      to={`http://www.fluxod.com/${api}/reservations/${ids?.reservation_id}/redirect_to_real_controller`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "PME" && ids?.pme_id != null ? (
                    <Link
                      to={`${backUrl}/pmes/${ids.pme_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Investissement" &&
                    ids?.investissement_id != null ? (
                    <Link
                      to={`${backUrl}/investissements/${ids.investissement_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Exploitant" && ids?.partenaire2_id != null ? (
                    <Link
                      to={`${backUrl}/partenaires_exploitants/${ids.partenaire2_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : key == "Comptable" && ids?.contact2_id != null ? (
                    <Link
                      to={`${backUrl}/partenaires_industriels/${ids.contact2_id}`}
                      className="text-decoration-underline"
                      style={{
                        color: "#555B21",
                      }}
                    >
                      {value}
                    </Link>
                  ) : (
                    renderValue(value)
                  )}
                  {}
                </span>
              </Col>
            </Row>
          ))
        ) : (
          <></>
        )}
      </CardBody>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé" || value === "Oui") {
    return <span className="bg-success badge bg-secondary">{value}</span>;
  } else if (value === "En attente") {
    return <span className="bg-info badge bg-secondary">{value}</span>;
  } else if (value === "Non") {
    return (
      <span
        className="badge-soft-danger badge bg-secondary"
        style={{ fontSize: "100%" }}
      >
        {value}
      </span>
    );
  } else {
    return value;
  }
};
export default SouscriptionsCard;
